<template>
  <section class="flex min-h-80 w-full flex-col items-center gap-4 bg-green-20 pt-8 text-center text-green-50">
    <h3 class="mt-12 mb-2 font-headline text-xl font-medium tracking-[0.1rem]">
      Hold deg oppdatert
    </h3>
    <p class="mx-4 mb-8 max-w-2xl">
      Med nyhetsbrev fra Aschehoug får du tips til undervisningen, inspirerende
      artikler, og invitasjoner til arrangementer.
    </p>
    <UButton
      class="z-1 rounded-full bg-[#fffae9] px-m py-xs text-green-50 no-underline hover:bg-yellow-30"
      size="xl"
      :to="{ name: 'nyhetsbrev' }"
    >
      Meld deg på
    </UButton>
    <div class="relative mt-32 min-h-24 w-full bg-green-50 tablet:mt-48 [&_img]:max-w-[unset]">
      <UiGraphicsFigureElementGroupA class="figure-1" />
      <UiGraphicsFigureElementAloneA class="figure-2" />
      <UiGraphicsFigureElementGroupB class="figure-3" />
    </div>
  </section>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.figure-1 {
  position: absolute;
  top: -7rem;
  left: 10%;
  transform: scale(0.6);

  @media screen and (min-width: theme("screens.tablet")) {
    transform: scale(1);
    left: 20%;
    top: -13rem;
  }
}

.figure-2 {
  position: absolute;
  top: -7rem;
  left: 30%;
  transform: scale(0.6);

  @media screen and (min-width: theme("screens.sm")) {
    left: 30%;
  }

  @media screen and (min-width: theme("screens.tablet")) {
    left: 40%;
    top: -12rem;
    transform: scale(1);
  }
}

.figure-3 {
  position: absolute;
  top: -7rem;
  left: 50%;
  transform: scale(0.6);

  @media screen and (min-width: theme("screens.tablet")) {
    transform: scale(1);
    left: 55%;
    top: -13rem;
  }
}
</style>
